import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';
import BaseField from '../field.js';

import { FIELD_GROUPS, GROUP_MAP } from '../constants.js';

export default {
  components: {
    FieldView: BaseField,
    Dropdown: DropdownSelect,
  },

  props: ['field', 'index', 'exceptions', 'disables', 'fieldGroupOptions', 'disabledFieldLayout'],

  data() {
    return {
      editing: false,
      type: '',
      field_group_options: this.fieldGroupOptions || FIELD_GROUPS,
    };
  },

  created() {
    this.editing = this.field._editing;
    this.field.position = this.index;
    if (this.$parent.children == null) this.$parent.children = [];
    this.$parent.children.push(this);
  },

  watch: {
    editing(newValue) {
      this._enableBackdrop();
      if (newValue) {
        this.$nextTick(() => this.focusTitleIfNeed());
      }
    },
  },

  computed: {
    currentOption() {
      if (!this.optionbarContent.length) return null;
      return _.find(this.optionbarContent, (option) => {
        if (option.type === 'Field::DateTime') {
          return option.params.input_type === this.field.settings.input_type;
        }
        return option.type === this.field.type;
      });
    },

    optionbarContent() {
      return this._getOptionbarContent(this.type);
    },

    availableLayouts() {
      return this.field.availableLayouts;
    },

    field_groups() {
      if (this.field.type === 'Field::SectionBreak') return [];
      return _.chain(this.field_group_options)
        .map((group) => ({
          options: this._getAvailableTypes(group.options, this.exceptions),
        }))
        .filter((group) => group.options.length)
        .value();
    },
  },

  methods: {
    changeType(option) {
      if (option.type === 'Field::DateTime') {
        if (option.params.input_type === this.field.settings.input_type) return;
      } else if (option.type === this.field.type) {
        return;
      }

      if (/Field::/.test(option.type)) {
        this._updateType(option.type, option.params);
      } else {
        const fieldOption = _.first(this._getOptionbarContent(option.type));
        if (!fieldOption) return;
        this._updateType(fieldOption.type, fieldOption.params);
      }
    },

    removeField() {
      this._removeBackdrop();
      this.$emit('removeField', this.field);
    },

    copyField() {
      const newField = this._cloneField(this.field);
      this.$emit('copyField', newField, this.index);
    },

    quitEditing() {
      this.editing = false;
    },

    focusTitleIfNeed() {
      if (!this.field.title) this.$refs.fieldView.focusTitle();
    },

    validate() {
      return true;
    },

    _updateType(newType, params) {
      const newField = this.field.changeType(newType, params);
      newField._editing = true;
      this._removeBackdrop();
      this.$emit('fieldTypeChange', newField, this.index);
    },

    _cloneField(field) {
      const newField = _.clone(field);
      newField.uuid = Skylark.Helpers.Utilities.uuid();
      newField.settings = _.clone(field.settings);
      if (field.type === 'Field::CheckBox') {
        newField.settings.length_limit = _.clone((field.settings && field.settings.length_limit) || {});
      }
      newField.validations = _.clone(field.validations);
      delete newField.id;
      delete newField._editing;
      delete newField.identity_key;
      if (field.options && field.options.length) {
        newField.options = _.map(field.options, (option) => new Skylark.App.Model.FieldOption({
          value: option.value,
          uuid: Skylark.Helpers.Utilities.uuid(),
          settings: {
            limit_settings: {
              max: option.settings && option.settings.limit_settings && option.settings.limit_settings.max,
              text: option.settings && option.settings.limit_settings && option.settings.limit_settings.text,
            },
          },
          _destroy: false,
        }));
      }
      if (field.children && field.children.length) {
        newField.children = _.map(field.children, (child) => (
          Skylark.App.Model.Field.Base.new(this._cloneField(child), child.logic_rule, child.fieldable)
        ));
      }
      return Skylark.App.Model.Field.Base.new(newField, newField.logic_rule, newField.fieldable);
    },

    _getOptionbarContent(key) {
      return this._getAvailableTypes(GROUP_MAP[key] || [], this.exceptions);
    },

    _getAvailableTypes(array, exceptions) {
      return _.filter(array, (item) => !_.contains(exceptions, item.type));
    },

    _getTypeText(type) {
      return Skylark.Helpers.getZH_CN(`field.type.${type}`);
    },

    _getTypeTextOfField(field) {
      return this._getTypeText(field.type === 'Field::DateTime' ? field.params.input_type : field.type);
    },

    _wrapDropdownOptions(options) {
      return [{ options }];
    },

    _enableBackdrop() {
      if (!this.editing) return;
      this._backdrop_id = Skylark.Helpers.App.capturedBackdrop((event) => {
        const fieldView = event.target.closest('.field-view');
        if ((fieldView && fieldView.getAttribute('moved'))
          || event.target.closest('.formable-actions')
          || event.target.closest('.js-add-field')) {
          return { force_clean: false };
        }
        this.editing = false;
        this.$emit('fieldBlured', this, event);
        return undefined;
      }, this.$el);
    },

    _removeBackdrop() {
      Skylark.Helpers.App.removeCapturedBackdropByID(this._backdrop_id);
    },
  },
};
